import { render, staticRenderFns } from "./IzvestajPreostalogRV.vue?vue&type=template&id=6a0d9e2c&scoped=true&"
import script from "./IzvestajPreostalogRV.vue?vue&type=script&lang=ts&"
export * from "./IzvestajPreostalogRV.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0d9e2c",
  null
  
)

export default component.exports